// extracted by mini-css-extract-plugin
export default {"close":"popup-dialog__close___Ox1Ys","content":"popup-dialog__content___kKjnI"};